// extracted by mini-css-extract-plugin
export default {"container":"ProgessBar_container__IHP-P","text":"ProgessBar_text__TMIcz","progress":"ProgessBar_progress__9W1FA","bar":"ProgessBar_bar__2AnNB"};